import React from 'react'
import Modal from 'react-responsive-modal';
import {Flex} from '/app/src/component'
import style from './style.css'

export default class JibberModal extends React.Component {
    render() {
       return(
       <Modal
          animationDuration={100}
        styles={{
            'modal': {
                'padding': '0px',
                'borderRadius': '20px',
                'backgroundColor': '#404040'
            },
            'overlay': {
                'background': 'transparent'

            },
            'closeIcon': {
                'fill': '#a5a5a5',
                'cursor': 'pointer'
            }
        }}
        onClose={this.props.onClose}
        open={this.props.open}>
        <Flex className={style.ModalWrapper} column>
            <Flex center className={style.Header}> {this.props.title}</Flex>
            <Flex grow className={style.Body}> {this.props.children}</Flex>
        </Flex>
       </Modal>
       )
    }
}



// WEBPACK FOOTER //
// ./src/component/Modal/Modal.js